import { Component, Input } from '@angular/core';
import { TableModule } from 'primeng/table';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule, NgClass } from '@angular/common';
import { ConfigService } from '../../../../../../shared/services/config.service';
import { PatientInfoComponent } from '../patient-info/patient-info.component';

@Component({
  selector: 'app-new-back-order-received',
  standalone: true,
  imports: [TableModule, TranslateModule, NgClass, CommonModule, PatientInfoComponent],
  templateUrl: './new-back-order-received.component.html',
  styleUrl: './new-back-order-received.component.scss'
})
export class NewBackOrderReceivedComponent {
  @Input() orderStatus: string;
  @Input() products: any[];
  @Input() orderSummary: any[];
  @Input() isPatientManagmentOn: boolean = false;
  showPatientDialog = false;
  selectedPatientCodes: string[] = [];

  constructor(public configService: ConfigService) { }

  openPatientDialog(patientCodes: string[]) {
    this.selectedPatientCodes = patientCodes;
    this.showPatientDialog = true;
  }

  closePatientDialog() {
    this.showPatientDialog = false;
    this.selectedPatientCodes = [];
  }
}
